import * as React from 'react'
import { ConfirmStripeACHConnection } from '../../externalServices/stripe/ConfirmACHConnection'
import { ConnectBankAccountForm } from '../../externalServices/stripe/ConnectBankAccountForm'
import { useOrgQuery } from '../organization/useOrg'
import { getBillableType } from './billingUtils'
import { ConnectBillingSourceProps } from './types'
import { useBillingClientSecret } from './useBillingClientSecret'
import { useSetBankingAccount } from './useSetBankingAccount'
import { useOrgId } from '../useOrgId'

export const ACHBillingSourceInput = ({
  billable,
  clientSecret,
  onSuccess,
  onBankSelected,
}: Omit<ConnectBillingSourceProps, 'onError'> & { clientSecret: string; onBankSelected?: () => void }) => {
  const [showACHMandate, setShowACHMandate] = React.useState(false)
  const { mutate: setBankingAccount } = useSetBankingAccount(
    { ownerId: billable.id, ownerType: getBillableType(billable) },
    [useOrgQuery.getKey({ orgId: useOrgId() })], // eventually we might need to invalidate a billable-specific query
    { onSuccess }
  )

  if (!clientSecret) return null

  if (showACHMandate) {
    return (
      <ConfirmStripeACHConnection
        type="billing"
        clientSecret={clientSecret}
        handleConfirmationResponse={setBankingAccount}
        invalidationKeys={[useBillingClientSecret.getKey(billable)]}
      />
    )
  }
  return (
    <ConnectBankAccountForm
      clientSecret={clientSecret}
      onSuccess={() => {
        setShowACHMandate(true)
        onBankSelected?.()
      }}
    />
  )
}
